import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { AvatarModule } from '../../../components/avatar/avatar.module';
import { TranslateModule } from '../../../components/translate/translate.module';
import { AnalyticsClickDirective } from '../../../directives/analytics/analytics-click.directive';
import { UserCardModule } from '../../../directives/user-card/user-card.module';
import { DaterModule } from '../../../pipes/dater/dater.module';
import { IconPipeModule } from '../../../pipes/icon/icon-pipe.module';
import { ListArrayPipeModule } from '../../../pipes/list-array/list-array.pipe.module';
import { CaseService } from '../case.service';
import { ClientsFromCasePipe } from '../pipes/clients-from-case.pipe';
import { ContractorsFromCasePipe } from '../pipes/contractors-from-case.pipe';
import IsCaseDeclinedPipe from '../pipes/is-case-declined.pipe';
import IsCasePendingPipe from '../pipes/is-case-pending.pipe';
import IsDateOverduePipe from '../pipes/is-date-overdue.pipe';
import {
  StatusColorForContractorPipe,
  StatusIconForContractorPipe,
  StatusMessageForContractorPipe,
} from '../pipes/status-for-contractor.pipe';
import { CaseListComponent } from './list.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,

    // Material modules
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatDialogModule,
    MatMenuModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRippleModule,
    MatCheckboxModule,
    MatListModule,

    // App modules
    TranslateModule,
    DaterModule,
    IconPipeModule,
    ListArrayPipeModule,
    AvatarModule,
    UserCardModule,

    // Directives and Pipes
    AnalyticsClickDirective,
    ClientsFromCasePipe,
    ContractorsFromCasePipe,
    IsCaseDeclinedPipe,
    IsCasePendingPipe,
    IsDateOverduePipe,
    StatusColorForContractorPipe,
    StatusIconForContractorPipe,
    StatusMessageForContractorPipe,
  ],
  declarations: [CaseListComponent],
  exports: [CaseListComponent],
  providers: [CaseService],
})
export class CaseListModule {}
